var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../types.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { D as DieOnTimeoutSchema } from "../../DieOnTimeout-1359a71f.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
class DieOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "DieOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", DieOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTyped(entity, DieOnTimeoutSchema);
    updateTimeout(entity, data, gameModel);
  }
}
registerSystem(DieOnTimeoutSystem);
function updateTimeout(entity, timeout, gameModel) {
  timeout.timeElapsed += gameModel.dt(entity);
  if (timeout.timeElapsed > timeout.timeout) {
    gameModel.getComponentUnsafe(entity, "Health").health = 0;
  }
}
//# sourceMappingURL=DieOnTimeout.js.map
